import React from 'react';
import ListItem from '../../../elements/ListItem/ListItem';
import { ListItemContent } from '../../../elements/ListItem/ListItemContent';
import moment from 'moment';
import { ListItemImage } from '../../../elements/ListItem/ListItemImage';
import styles from './EventNotificationsItem.module.scss';
import RightChevron from '../../../elements/RightChevron/RightChevron';

/**
 * Receives one news item (from news or notifications) generated by useNewsMergedWithNotifications and shows it
 *
 * @param {object} props
 */
function EventNotificationsItem(props) {
    const { item } = props;

    return (
        <ListItem>
            <ListItemImage className={styles.icon} src={item.icon} />
            <ListItemContent href={item.href}>
                <p className={['text', 'main', item.read ? '' : styles.unread].join(' ')}>{item.title}</p>
                <p className="text">{moment(item.timestamp).format('llll')}</p>
            </ListItemContent>
            {item.href ? <RightChevron /> : null}
        </ListItem>
    );
}

export default EventNotificationsItem;
